<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div
        v-show="$route.path != '/Machine/SaveBillingMachinePayment/save'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-barcode"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>Phase:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'svPhase'"
                    :name="'svPhase'"
                    :select2-options="svPhaseOptions"
                    v-model="svPhase"
                    ref="svPhaseSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>Lot:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'svLot'"
                    :name="'svLot'"
                    :select2-options="svLotOptions"
                    v-model="svLot"
                    ref="svLotSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>งวดที่ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'svTracheNo'"
                    :name="'svTracheNo'"
                    :select2-options="svTrancheOptions"
                    v-model="svTracheNo"
                    ref="svTrancheSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="machineTransactionTable"
              >
                <thead>
                  <tr>
                    <th class="all">Supplier</th>
                    <th class="all">Phase</th>
                    <th class="all">Lot</th>
                    <th class="all">งวด</th>
                    <th class="all">ชื่อสินค้า</th>
                    <th class="all">ประเภทสินค้า</th>
                    <th class="all">แบรนด์สินค้า</th>
                    <th class="all">จำนวน</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
          <br />
          <form class="kt-form" ref="formSave" @submit="formSave">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group ">
                  <label class="label">วันที่วางบิล:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="svBilling"
                      name="svBilling"
                      ref="svBilling"
                      required
                      data-msg-required="กรุณาเลือก วันที่วางบิล"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>กรอกยอดเงินสุทธิ:</label>
                  <input
                    v-model="svAmount"
                    class="form-control"
                    placeholder="กรุณาระบุ ยอดเงินรวม"
                    required
                    data-msg-required="กรุณาระบุ ยอดเงินรวม"
                    v-currency="{
                      locale: 'th',
                      currency: null,
                      precision: 0,
                    }"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                <div class="form-group">
                  <label>เลขที่ Invoice:</label>
                  <input
                    v-model="svInvoice"
                    placeholder="กรุณาระบุ เลขที่ Invoice"
                    type="text"
                    maxlength="256"
                    class="form-control"
                    id="svInvoice"
                    name="svInvoice"
                    required
                    data-msg-required="กรุณาระบุ เลขที่ Invoice"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  บันทึกการวางบิล
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formSaveReset"
                >
                  ล้างค่า
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;
    return {
      svPhase: null,
      svLot: null,
      svTranche: null,
      svTracheNo: null,
      svOpenButton: false,
      svBilling: null,
      svAmount: null,
      svInvoice: null,
      svPhaseOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      svLotOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Lot",
          data: function(params) {
            var query = {
              search: params.term,
              Phase: self.svPhase,
              page: params.page || 1,
              isPaid: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      svTrancheOptions: {
        placeholder: "กรุณาเลือกงวด",
        allowClear: true,
        ajax: {
          url: "/Api/MachinePayment/Select2Tranche",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              billStatus: false,
              paymentStatus: false,
              phase: self.svPhase,
              lot: self.svLot,
              isPaid: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      var self = this;
      self.svPhase = null;
      self.svLot = null;
      self.svTracheNo = null;
      self.svAmount = null;
      self.svInvoice = null;
      self.svBilling = null;

      $("#svPhase")
        .val("")
        .trigger("change");

      $("#svLot")
        .val("")
        .trigger("change");

      $("#svTracheNo")
        .val("")
        .trigger("change");

      $("#svBilling")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#machineTransactionTable").DataTable();
      table.draw();
    },
    formSave: function(e) {
      let self = this;
      let router = this.$router;
      e.preventDefault();
      var valid = false;
      if (
        !$(self.$refs.formSave)
          .validate()
          .form()
      ) {
        return false;
      }
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/MachinePayment/Add", {
          Phase: self.svPhase,
          Lot: self.svLot,
          Tranche: self.svTracheNo,
          BillingDate:
            self.svBilling != null
              ? self.svBilling.format("YYYY-MM-DD")
              : self.svBilling,
          Invoice: self.svInvoice,
          Amount: self.svAmount,
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                //router.go(), self.$parent.reloadDataTable(false);
                self.formReset(e);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    formSaveReset: function(e) {
      var self = this;
      self.svAmount = null;
      self.svInvoice = null;
      self.svBilling = null;
    },
  },
  async mounted() {
    let self = this;
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#machineTransactionTable");
    table.DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/MachinePayment/Search",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          return JSON.stringify(
            $.extend(d, {
              Phase: self.svPhase,
              Lot: self.svLot,
              Tranche: self.svTracheNo,
            })
          );
        },
      },

      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [100, 500],

      pageLength: 100,

      language: {
        lengthMenu: "Display _MENU_",
      },

      // Order settings
      order: [[1, "desc"]],
      columns: [
        { data: "supplier" },
        { data: "phase" },
        { data: "lot" },
        { data: "tranche" },
        { data: "productName" },
        { data: "productType" },
        { data: "productBrand" },
        { data: "count" },
      ],
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    $(self.$refs.svBilling).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.svBilling)
      .datepicker(
        "update",
        !!self.svBilling ? self.svBilling.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.svBilling = e.dates.length != 0 ? moment(e.date) : null;
      });

    // set validation rules
    $(self.$refs.formSave).validate({
      rules: {
        svBilling: "required",
        svAmount: "required",
        svInvoice: "required",
      },
      messages: {
        svBilling: "กรุณาเลือกวันที่",
        svAmount: "กรุณากรอกจำนวนยอดรวม",
        svInvoice: "กรุณากรอกเลขที่ Invoice",
      },
    });
    $(self.$refs.formSave).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Machine/SaveBillingMachinePayment.vue